// import React from 'react';
import './SipoMeter.css';
import React, { useState, useEffect } from 'react';
import CircularSlider from '@fseehawer/react-circular-slider';

const SipoMeter = () => {
  const [targetCorpus, setTargetCorpus] = useState(1000000); // ₹10L default
  const [returnRate, setReturnRate] = useState(12); // 12% default
  const [duration, setDuration] = useState(10); // in years
  const [monthlySIP, setMonthlySIP] = useState(null);

  useEffect(() => {
    calculateSIP();
  }, [targetCorpus, returnRate, duration]);

  const calculateSIP = () => {
    const r = returnRate / 12 / 100;
    const n = duration * 12;
    const sip = targetCorpus * (r / ((Math.pow(1 + r, n) - 1) * (1 + r)));
    setMonthlySIP(Math.round(sip));
  };

  return (
    <div className="sip-o-meter">
      <h2 className="text-center">SIP-O-Meter</h2>

      <div className="slider-group">
        <h5>Select Target Corpus</h5>
        <CircularSlider
          label="Target"
          width={200}
          data={['₹10L', '₹20L', '₹50L', '₹1Cr', '₹5Cr', '₹10Cr', '₹20Cr', '₹30Cr', '₹40Cr', '₹50Cr']}
          dataIndex={0}
          onChange={(value) => {
            let numericValue = 1000000;
            if (value === '₹20L') numericValue = 2000000;
            else if (value === '₹50L') numericValue = 5000000;
            else if (value === '₹1Cr') numericValue = 10000000;
            else if (value === '₹5Cr') numericValue = 50000000;
            else if (value === '₹10Cr') numericValue = 100000000;
            else if (value === '₹20Cr') numericValue = 2000000000;
            else if (value === '₹30Cr') numericValue = 3000000000;
            else if (value === '₹40Cr') numericValue = 4000000000;
            else if (value === '₹50Cr') numericValue = 5000000000;

            setTargetCorpus(numericValue);
          }}
        />
      </div>

      <div className="slider-group">
        <h5>Select Return Rate</h5>
        <CircularSlider
          label="Return %"
          width={200}
  data={[
      '8%', '10%', '12%', '14%', '16%', '18%', '20%', '22%', '24%', '26%',
      '28%', '30%', '32%', '34%', '36%', '38%', '40%', '42%', '44%', '46%',
      '48%', '50%'
    ]}          dataIndex={1}
          onChange={(value) => {
            const numeric = parseInt(value);
            setReturnRate(numeric);
          }}
        />
      </div>

      <div className="form-group">
        <label>Investment Duration (in years):</label>
        <select
          className="form-control"
          value={duration}
          onChange={(e) => setDuration(Number(e.target.value))}
        >
          {[5, 10, 15, 20, 25, 30].map((year) => (
            <option key={year} value={year}>
              {year} Years
            </option>
          ))}
        </select>
      </div>

      <div className="result-box mt-4">
        {monthlySIP !== null && (
          <h4 className="text-success">
            Monthly SIP Required: ₹{monthlySIP.toLocaleString()}
          </h4>
        )}
      </div>
    </div>
  );
};

export default SipoMeter;